// 📁 frontend/src/pages/AdminLoginPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../api/api';

function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // ✅ تحويل إذا كان المشرف مسجل دخول مسبقًا
  useEffect(() => {
    const admin = localStorage.getItem('admin');
    if (admin) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await adminLogin({ email, password });
      if (res.status) {
        localStorage.setItem('admin', JSON.stringify(res.user));
        navigate('/admin/dashboard'); // ✅ توجيه
      } else {
        setError(res.message || 'فشل تسجيل الدخول');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'حدث خطأ غير متوقع');
    }
  };

  return (
    <div
      style={{
        direction: 'rtl',
        fontFamily: "'Cairo', sans-serif",
        backgroundColor: '#f3f4f6',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '380px',
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
          padding: '25px',
          textAlign: 'center',
        }}
      >
        <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '10px', color: '#2d3436' }}>
          🔐 تسجيل دخول المشرف
        </h2>
        <p style={{ color: '#636e72', marginBottom: '25px', fontSize: '14px' }}>
          يرجى إدخال بياناتك للوصول إلى لوحة التحكم
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '18px', textAlign: 'right' }}>
            <label style={{ fontSize: '14px', fontWeight: '600', color: '#2d3436' }}>
              📧 البريد الإلكتروني:
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                marginTop: '6px',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #dfe6e9',
                fontSize: '15px',
              }}
            />
          </div>

          <div style={{ marginBottom: '18px', textAlign: 'right' }}>
            <label style={{ fontSize: '14px', fontWeight: '600', color: '#2d3436' }}>
              🔑 كلمة المرور:
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                marginTop: '6px',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #dfe6e9',
                fontSize: '15px',
              }}
            />
          </div>

          {/* رسالة خطأ (إذا وجدت) */}
          {error && (
            <div
              style={{
                backgroundColor: '#fdecea',
                color: '#e74c3c',
                padding: '10px',
                borderRadius: '8px',
                marginBottom: '15px',
                fontSize: '14px',
              }}
            >
              ❌ {error}
            </div>
          )}

          <button
            type="submit"
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#27ae60',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '700',
              fontSize: '16px',
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(39,174,96,0.25)',
            }}
          >
            🚪 دخول
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLoginPage;
